import FalForm1 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm1";
import FalForm2 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm2";
import FalForm3 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm3";
import FalForm4 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm4";
import FalForm5 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm5";
import FalForm6 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm6";
import FalForm7 from "@features/vessel-call/create/steps/ImoFAL/steps/FalForm7";
import { useParams } from "react-router-dom";

const ImoFALRenderer = () => {
  const { type } = useParams();

  switch (type) {
    case "fal-form-1":
      return <FalForm1 />;
    case "fal-form-2":
      return <FalForm2 />;
    case "fal-form-3":
      return <FalForm3 />;
    case "fal-form-4":
      return <FalForm4 />;
    case "fal-form-5":
      return <FalForm5 />;
    case "fal-form-6":
      return <FalForm6 />;
    case "fal-form-7":
      return <FalForm7 />;
    default:
      return <div>Unknown Type</div>;
  }
};

export default ImoFALRenderer;
